export default "__VITE_ASSET__C4bNlse9__"